import { DATA_SOURCE_LIST_ERROR, DATA_SOURCE_LIST, DATA_SOURCE_LIST_SUCCESS, EDIT_DATASOURCE_CONFIG, EDIT_DATASOURCE_CONFIG_ERROR, EDIT_DATASOURCE_CONFIG_SUCCESS, DATASOURCE_CREATE_ERROR, DATASOURCE_CREATE, DATASOURCE_CREATE_SUCCESS, DATASOURCE_UPDATE_DATA,  DATA_SOURCE_DELETE, DATA_SOURCE_DELETE_SUCCESS, DATA_SOURCE_DELETE_ERROR } from './constants';

export default function datasourceInfoReducer(state, action) {
	let datasource = [];
	switch (action.type) {
	
	case DATASOURCE_UPDATE_DATA :
		return { ...state, datasourceUpdateData : action.payload };
	case DATASOURCE_CREATE:
		return { ...state, loading : true, error : false };
	case DATASOURCE_CREATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case DATASOURCE_CREATE_ERROR :
		return { ...state, loading : false, error : true };
	case DATA_SOURCE_DELETE :
		return { ...state, loading : true, error : false};
	case DATA_SOURCE_DELETE_SUCCESS :
		return { ...state, loading : false, error : false };
	case DATA_SOURCE_DELETE_ERROR :
		return { ...state, loading : false, error : true };

	case EDIT_DATASOURCE_CONFIG :
		return {...state, loading : true , error : false};
	case EDIT_DATASOURCE_CONFIG_SUCCESS :
		return {...state, loading : false , error : false};
	case EDIT_DATASOURCE_CONFIG_ERROR :
		return {...state, loading : false , error : true};

	case DATA_SOURCE_LIST:
		return {...state, loading : false , error : false};
	case DATA_SOURCE_LIST_SUCCESS:
		if (action.payload && action?.payload?.data?.length > 0) {
			
			action?.payload?.data?.map( (item) => {
				let data = {};
				data.id = item.id ? item.id : 0;
				data.name = item.name,
				data.configs = item.configs,
				data.pipelineId = item.pipelineId ? item.pipelineId : 0;
				data.channelinfoId = item.channelinfoId ? item.channelinfoId : 0;
				data.pidsinfoId = item.pidsinfoId ? item.pidsinfoId : 0;
				data.channelname = item?.channelinfo && item?.channelinfo?.name ? item?.channelinfo?.name : ''; 
				data.pidsinfo = item?.pidsinfo && item?.pidsinfo?.name ? item?.pidsinfo?.name : ''; 
				
				return datasource.push(data);
			});
			return { ...state, datasource:datasource ,  loading: false, error: false };
		}
		else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, datasource: [], pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}

	case DATA_SOURCE_LIST_ERROR:
		return {...state, loading : false , error : true};
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}